import { useLayoutEffect } from 'react';
import { attachMagneticButtons } from '../lib/magneticButtons.js';
import '../css/magnetic-buttons.css';

/**
 * hooks/useMagneticScope.js -- Da el efecto magnetico a los botones primarios de una pantalla que vive FUERA de
 * RouteContent (login, registro). Dentro de la app, RouteContent ya lo hace. El contenedor debe llevar la clase
 * `magnetic-scope` (el CSS la reconoce igual que a `.route-content`). Los modales siguen excluidos.
 */
export function useMagneticScope(ref) {
  useLayoutEffect(() => attachMagneticButtons(ref.current), [ref]);
}
